import React from "react";

import { SliderItem } from "../../features/auth/store/types/slider-types";

interface SLiderCardProps {
  item: SliderItem;
  onEdit?: (item: SliderItem) => void;
  onDelete?: (item: SliderItem) => void;
}

export const SliderCard: React.FC<SLiderCardProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="flex items-center gap-4 p-3 rounded-lg border border-gray-200 bg-white dark:text-white dark:bg-[#FFFFFF1A] dark:border-[#FFFFFF1A]">
      <img
        src={item.image_url ?? "/placeholder.png"}
        alt={item.title ?? "slider"}
        className="w-24 h-14 object-cover rounded-md"
      />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-gray-900 truncate">
          {item.title}
        </div>
        <a
          href={item.url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-blue-600 break-all"
        >
          {item.url}
        </a>
      </div>
      <div className="flex gap-2">
        <button
          className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded"
          onClick={() => onEdit?.(item)}
        >
          Edit
        </button>
        <button
          className="px-3 py-1 bg-red-100 text-red-800 rounded"
          onClick={() => onDelete?.(item)}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export const SliderList: React.FC<{
  items: SliderItem[];
  onEdit?: (item: SliderItem) => void;
  onDelete?: (item: SliderItem) => void;
}> = ({ items, onEdit, onDelete }) => {
  if (!items || items.length === 0) {
    return <div className="text-sm text-gray-500">No sliders available</div>;
  }

  return (
    <div className="space-y-3">
      {items.map((it) => (
        <SliderCard key={it.id} item={it} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </div>
  );
};
